import type { ChatThinkingKind } from "../../api";

/**
 * What to call a tool round while it runs. Shared by every transcript view, and
 * exhaustive over `ChatThinkingKind` on purpose: a tool added to the backend
 * stops compiling here until it has been given something to say.
 */
export const chatThinkingTranslationKey = (kind: ChatThinkingKind) => {
  switch (kind) {
    case "analyzing_process_context":
      return "chat_thinking_analyzing_process_context";
    case "listing_recordings":
      return "chat_thinking_listing_recordings";
    case "reading_recording_metadata":
      return "chat_thinking_reading_recording_metadata";
    case "reading_process_instances":
      return "chat_thinking_reading_process_instances";
    case "inspecting_analysis_details":
      return "chat_thinking_inspecting_analysis_details";
    case "searching_in_nodes":
      return "chat_thinking_searching_in_nodes";
    case "computing_node_metrics":
      return "chat_thinking_computing_node_metrics";
    case "analyzing_screenshots":
      return "chat_thinking_analyzing_screenshots";
    case "running_subagents":
      return "chat_thinking_running_subagents";
    case "reasoning":
      return "chat_thinking_reasoning";
    case "preparing_final_answer":
      return "chat_thinking_preparing_final_answer";
  }
};
